import React from "react";
import cn from "classnames";

import styles from "./style.module.scss";
import { MessageID } from "../../i18n/types";
import { LocalisedText } from "../../i18n";
import { Values } from "@oursky/react-messageformat";

export interface ToastMessage {
  content: MessageID;
  values?: Values;
}

interface ToastProps {
  message: ToastMessage | null;
  isPresenting: boolean;
  isError: boolean;
}

const Toast: React.FC<ToastProps> = (props: ToastProps) => {
  const { message, isPresenting, isError } = props;
  return (
    <div
      className={cn(styles.toast, {
        [styles.presenting]: isPresenting,
        [styles.error]: isError,
      })}
    >
      <div className={styles.toastIcon} />
      <div className={styles.content}>
        {message != null && (
          <LocalisedText id={message.content} values={message.values} />
        )}
      </div>
    </div>
  );
};

export default Toast;
